'use client'

import { PropsWithChildren, ReactNode } from 'react'

export default function Layout({
  children,
  subCategoriesSlider,
}: PropsWithChildren<{
  subCategoriesSlider: ReactNode
}>) {
  return (
    <div className="category-layout tw-h-full tw-w-full">
      {/*<div className="tw-mx-2 tw-mb-6 tw-overflow-hidden">{subCategoriesSlider}</div>*/}
      {subCategoriesSlider}

      <div className="category-layout-content">{children}</div>
    </div>
  )
}
